import styled from "styled-components";

export const StepsContainer = styled.div`
  .logo-step-wrapper {
    width: 8%;
    text-align: center;
    padding: 3px 10px;
    justify-content: center;
    gap: 10px;
    border-radius: 48px;
    height: 30px;
    position: absolute;
    top: 45px;
    right: 38px;
    align-items: center;
    display: flex;

    &.btn {
      cursor: pointer;
      background: ${({ theme }) => theme.global.bg.primary};
    }

    span {
      color: #048af5;
      font-size: 12px;
    }

    .progress-bar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: radial-gradient(closest-side, white 80%, transparent 80% 100%),
        conic-gradient(#048af5 25%, #42424d 0);

      progress {
        visibility: hidden;
        width: 0;
        height: 0;
      }
    }
  }

  @media screen and (max-width: 922px) {
    &.hide {
      display: none;
    }

    .logo-step-wrapper {
      width: auto;
      min-width: 80px;
      max-width: 120px;
      padding: 2px 8px;
      height: 28px;
      top: 20px;
      right: 20px;

      span {
        font-size: 11px;
      }

      .progress-bar {
        width: 32px;
        height: 32px;
        flex-shrink: 0;
      }
    }
  }

  @media screen and (max-width: 576px) {
    .logo-step-wrapper {
      width: auto;
      min-width: 70px;
      max-width: 100px;
      padding: 2px 6px;
      height: 26px;
      top: 15px;
      right: 15px;

      span {
        font-size: 10px;
      }

      .progress-bar {
        width: 28px;
        height: 28px;
      }
    }
  }
`;
